export default __webpack_public_path__ + "static/media/01_DAIF_Data_04_07_end.2f4618d3.jpg";